export default __webpack_public_path__ + "static/media/2_CP_Next.9c3e6a07.png";